import type { AppModule } from '@/types/architecture'
import routes from './routes'

/**
 * Contract Reviews Module — AI-Powered Contract Analysis
 *
 * Enables users to upload PDF contracts for automated risk analysis
 * using specialized AI agents. Provides structured redline suggestions,
 * compliance breakdowns, diagnostics transparency, and on-demand
 * PDF report generation. Includes playbook management for customizing
 * organization-specific contract review policies.
 */
const contractReviewsModule: AppModule = {
    id: 'contract-reviews',
    navigation: {
        label: 'Contracts',
        icon: 'scale',
        path: '/contract-reviews',
        order: 79,
        moduleKey: 'contracts',
        pages: [
            {
                label: 'All Reviews',
                path: '/contract-reviews',
                icon: 'scale',
            },
            {
                label: 'Playbooks',
                path: '/contract-reviews/playbooks',
                icon: 'book-open',
            },
            {
                label: 'Riders',
                path: '/contract-reviews/riders',
                icon: 'file-text',
            },
            {
                label: 'Configuration',
                path: '/contract-reviews/configuration',
                icon: 'settings',
            },
        ],
    },
    routes,
}

export default contractReviewsModule
